import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { VerifySKR } from './pages/VerifySKR';
import { Contact } from './pages/Contact';
import { Admin } from './pages/Admin';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3f8ezjl48lvuq">
      <Routes data-id="element-1" data-mp="2rkx3vehuqdmh">
        <Route element={<Layout data-id="element-3" data-mp="2rk46v58p32hj" />} data-id="element-2" data-mp="2rknlabz4z8qt">
          <Route path="/" element={<Home data-id="element-5" data-mp="2rit1x23ijoou" />} data-id="element-4" data-mp="2rlowqhk2dx92" />
          <Route path="/services" element={<Services data-id="element-7" data-mp="2mmlvz9b4ad6w" />} data-id="element-6" data-mp="2mlubatj25zve" />
          <Route path="/verify" element={<VerifySKR data-id="element-9" data-mp="2mjzmv58kvpmk" />} data-id="element-8" data-mp="2mndqshww46w4" />
          <Route path="/contact" element={<Contact data-id="element-11" data-mp="31bianp7oiogh" />} data-id="element-10" data-mp="31b8ko1mmwhas" />
          <Route path="/admin" element={<Admin data-id="element-13" data-mp="2wka1mua9h53u" />} data-id="element-12" data-mp="31ctd9lpe1q60" />
        </Route>
      </Routes>
    </BrowserRouter>;
}